<template>
  <!-- <div v-if="!changeBig.big"> -->
  <div
    class="container"
    :class="{ 'container--full': isPcDealer }"
    v-if="!isShowMobile || isPcDealer"
  >
    <router-view v-slot="{ Component, route }">
      <!-- v-if="destoryAllCache" -->
      <keep-alive :key="keepKey">
        <component
          :is="Component"
          v-if="route.meta.keepAlive"
          :key="route.name"
        />
      </keep-alive>
      <component
        :is="Component"
        v-if="!route.meta.keepAlive"
        :key="route.name"
      />
    </router-view>
  </div>
  <div class="app" v-if="isShowMobile && !isReport && !isPcDealer">
    <div class="frame-outer" :style="{ backgroundColor: theme.bg }">
      <!-- 主题切换 (仅PC) -->
      <!-- <div class="theme-selector hidden lg:flex">
        <button
          v-for="t in THEMES"
          :key="t.id"
          @click="activeThemeId = t.id"
          :class="{ active: activeThemeId === t.id }"
          :style="{ backgroundColor: t.accent }"
        ></button>
      </div> -->

      <!-- <aside class="theme-panel hidden lg:flex">
        <div class="panel-header" :class="{ dark: isDark }">
          <span class="label"> {{ $t("app.apptheme.themesystem") }}</span>
          <span class="count">{{ activeThemeId }} / 20</span>
        </div>
        <div class="grid-container no-scrollbar">
          <button
            v-for="t in THEMES"
            :key="t.id"
            @click="handleThemeClick(t)"
            :class="{ active: activeThemeId == t.id }"
            :style="{
              backgroundColor: t.accent,
              color: t.name == '宇宙白' ? '#334155' : '#ffffff',
            }"
            :title="t.name"
          >
            {{ t.id }}
          </button>
        </div>
        <div class="theme-name" :class="{ dark: isDark }">
          {{ currentLang == "zh-CN" ? theme.name : theme.nameEn }}
        </div>
      </aside> -->

      <!-- 背景装饰 -->
      <div class="bg-layer hidden md:block">
        <!-- <div
          v-if="theme.pattern !== 'none'"
          class="pattern"
          :style="{ backgroundImage: `url(${getPatternUrl(theme.pattern)})` }"
        ></div> -->

        <div class="brand-side left">
          <img src="@/assets/logo.png" alt="Logo" />
          <div class="accent-line" :class="{ dark: isDark }"></div>
          <!-- :style="{ backgroundColor: theme.accentnew }" -->
          <p :class="{ dark: isDark }">Professional Protection</p>
        </div>

        <div class="brand-right">
          <h1 :class="{ dark: isDark }">PREMIUM</h1>
          <!-- <h2 :class="{ dark: isDark }"></h2> -->
          <div class="system-tag" :class="{ dark: isDark }">
            NBIZ-CFILM SYSTEM
          </div>
        </div>
        <div
          class="dynamic-glow"
          :style="{
            background: `radial-gradient(circle, ${theme.accent}15 0%, transparent 70%)`,
          }"
        ></div>
      </div>

      <!-- 手机内容区 -->
      <div class="phone-container">
        <div class="mobile-screen—inner">
          <main class="screen-content">
            <div class="inner_container">
              <router-view v-slot="{ Component, route }">
                <keep-alive :key="keepKey">
                  <component
                    :is="Component"
                    v-if="route.meta.keepAlive"
                    :key="route.name"
                  />
                </keep-alive>
                <component
                  :is="Component"
                  v-if="!route.meta.keepAlive"
                  :key="route.name"
                />
              </router-view>
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>

  <div class="report_app" v-if="isShowMobile && isReport && !isPcDealer">
    <div class="mobile-container-report">
      <div class="mobile-screen">
        <main class="screen-content">
          <div class="inner_container">
            <router-view v-slot="{ Component, route }">
              <keep-alive :key="keepKey">
                <component
                  :is="Component"
                  v-if="route.meta.keepAlive"
                  :key="route.name"
                />
              </keep-alive>
              <component
                :is="Component"
                v-if="!route.meta.keepAlive"
                :key="route.name"
              />
            </router-view>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, ref } from "@vue/reactivity";
import { onMounted, computed, watch, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { destoryAllCache } from "@/utils/globalUtils";
import { useKeepKeyEffect, useReportEffect } from "@/utils/cacheUtils";

import {
  getLanguageFlag,
  savePcThemeBgFlag,
  getPcThemeBgFlag,
} from "@/utils/localStorageUtils";
const THEMES = [
  {
    id: 1,
    name: "玄武黑",
    nameEn: "Obsidian Black",
    bg: "#000000",
    pattern: "carbon",
    accent: "#000000",
    accentnew: "#80000000",
  },

  {
    id: 2,
    name: "嘉实多经典",
    nameEn: "Castrol Classic",
    bg: "#009343",
    pattern: "hex",
    accent: "#009343",
  },
  {
    id: 3,
    name: "极光青",
    nameEn: "Aurora Cyan",
    bg: "#06b6d4",
    pattern: "dots",
    accent: "#06b6d4",
  },
  {
    id: 4,
    name: "烈焰红",
    nameEn: "Flame Red",
    bg: "#dc2626",
    pattern: "carbon",
    accent: "#dc2626",
  },
  {
    id: 5,
    name: "钛金灰",
    nameEn: "Titanium Grey",
    bg: "#a1a1aa",
    pattern: "grid",
    accent: "#a1a1aa",
  },
  {
    id: 6,
    name: "蔚蓝科技",
    nameEn: "Tech Azure",
    bg: "#2563eb",
    pattern: "hex",
    accent: "#2563eb",
  },
  {
    id: 7,
    name: "阳光金",
    nameEn: "Sunny Gold",
    bg: "#f59e0b",
    pattern: "dots",
    accent: "#f59e0b",
  },
  {
    id: 8,
    name: "午夜紫",
    nameEn: "Midnight Purple",
    bg: "#9333ea",
    pattern: "hex",
    accent: "#9333ea",
  },
  {
    id: 9,
    name: "极简白",
    nameEn: "Minimalist White",
    bg: "#cbd5e1",
    pattern: "grid",
    accent: "#cbd5e1",
  },
  {
    id: 10,
    name: "翡翠绿",
    nameEn: "Emerald Green",
    bg: "#10b981",
    pattern: "dots",
    accent: "#10b981",
  },
  {
    id: 11,
    name: "深海蓝",
    nameEn: "Deep Sea Blue",
    bg: "#6366f1",
    pattern: "hex",
    accent: "#6366f1",
  },
  {
    id: 12,
    name: "工业风",
    nameEn: "Industrial Style",
    bg: "#f97316",
    pattern: "grid",
    accent: "#f97316",
  },
  {
    id: 13,
    name: "冰川蓝",
    nameEn: "Glacier Blue",
    bg: "#38bdf8",
    pattern: "dots",
    accent: "#38bdf8",
  },
  {
    id: 14,
    name: "幻影灰",
    nameEn: "Phantom Grey",
    bg: "#64748b",
    pattern: "carbon",
    accent: "#64748b",
  },
  {
    id: 15,
    name: "暮色金",
    nameEn: "Twilight Gold",
    bg: "#eab308",
    pattern: "hex",
    accent: "#eab308",
  },
  {
    id: 16,
    name: "量子蓝",
    nameEn: "Quantum Blue",
    bg: "#60a5fa",
    pattern: "grid",
    accent: "#60a5fa",
  },
  {
    id: 17,
    name: "黑金",
    nameEn: "Black Gold",
    bg: "#ca8a04",
    pattern: "hex",
    accent: "#ca8a04",
  },
  {
    id: 18,
    name: "碳纤黑",
    nameEn: "Carbon Fiber Black",
    bg: "#334155",
    pattern: "dots",
    accent: "#334155",
  },
  {
    id: 19,
    name: "宇宙白",
    nameEn: "Cosmic White",
    bg: "#ffffff",
    pattern: "none",
    accent: "#ffffff",
  },
  {
    id: 20,
    name: "液态银",
    nameEn: "Liquid Silver",
    bg: "#94a3b8",
    pattern: "carbon",
    accent: "#94a3b8",
  },
];

export const useUIChangeEffect = () => {
  const changeBig = reactive({
    big: false,
  });
  return { changeBig };
};

export default {
  setup() {
    const isShowMobile = ref(false);
    const route = useRoute();
    const isPcDealer = computed(
      () =>
        route.name === "DealerPc" ||
        route.name === "DealerPcMapTiler" ||
        route.name === "PpfQuotePc" ||
        route.meta?.fullPage === true
    );
    const { keepKey } = useKeepKeyEffect();
    const { isReport } = useReportEffect();
    // console.log('isReport',isReport.value)
    const activeThemeId = ref(getPcThemeBgFlag() ? getPcThemeBgFlag() : 1);

    const currentLang = ref(getLanguageFlag());

    const handleThemeClick = (t) => {
      activeThemeId.value = t.id;
      savePcThemeBgFlag(t.id);
    };
    // 2. 定义事件处理函数
    const handleLangChange = (event) => {
      // event.detail 包含了派发时传过来的 lang
      console.log("handleLangChange1111", event.detail);
      currentLang.value = event.detail;
    };
    onMounted(() => {
      const isMobile = window.innerWidth <= 768;
      console.log(isMobile ? "当前是手机端" : "当前是浏览器端");

      isShowMobile.value = !isMobile;

      // 3. 监听自定义事件
      window.addEventListener("lang-changed", handleLangChange);
    });
    onUnmounted(() => {
      // 4. 组件卸载时移除监听，防止内存泄漏
      window.removeEventListener("lang-changed", handleLangChange);
    });

    const LOGO_URL =
      "https://www.castrol-autofilm.com.cn/web/nbiz/cfilm/img/logo.2d7d4a4f.png";

    const theme = computed(() => {
      return THEMES.find((t) => t.id == activeThemeId.value) || THEMES[0];
    });
    const isDark = computed(
      () => !["极简白", "冰川蓝", "液态银", "宇宙白"].includes(theme.value.name)
    );

    // const isDark = computed(() => theme.value.id !== 2);
    // const getPatternUrl = (p) => {
    //   const patterns = {
    //     hex: "https://www.transparenttextures.com/patterns/hexellence.png",
    //     carbon: "https://www.transparenttextures.com/patterns/carbon-fibre.png",
    //     grid: "https://www.transparenttextures.com/patterns/grid-me.png",
    //     dots: "https://www.transparenttextures.com/patterns/micro-carbon.png",
    //   };
    //   return patterns[p] || "";
    // };
    return {
      isShowMobile,
      isPcDealer,
      destoryAllCache,
      keepKey,
      isReport,
      THEMES,

      LOGO_URL,
      activeThemeId,
      theme,
      isDark,

      // getLanguageFlag,
      currentLang,
      handleThemeClick,
      // getPatternUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/viriables.scss";
// 定义变量以便复用
$mobile-aspect-ratio: 9 / 19.5;
$apple-out-expo: cubic-bezier(0.16, 1, 0.3, 1);


.container {
  position: relative;
  
  max-width: 600px; /* 设置最大宽度 */
  // max-width: 1000px; /* 设置最大宽度 */
  // width: 100%;
  height: 100%;
  // height: 100%;
  margin: 0 auto; /* 居中对齐 */
  // padding: 0 16px; /* 添加左右内边距，防止内容贴边 */
  // box-sizing: border-box; /* 确保宽度包含内边距 */
}

.container--full {
  max-width: none;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  margin: 0;
}
.inner_container {
  position: relative;
  // max-width: 600px; /* 设置最大宽度 */
  width: 100%;
  height: 100%;
  // height: 100%;
  margin: 0 auto; /* 居中对齐 */
}
.report_app {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100vh; /* 占满整个视口高度 */
  background-color: #f5f5f5; /* 背景颜色 */
  margin: 0;
  font-family: Arial, sans-serif;
}

.allcontainer {
  position: relative;
  height: 100%;
  margin: 0 auto; /* 居中对齐 */
  // padding: 0 16px; /* 添加左右内边距，防止内容贴边 */
  // box-sizing: border-box; /* 确保宽度包含内边距 */
}

/* 页面背景样式，确保居中对齐 */
.app {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100vh; /* 占满整个视口高度 */
  background-color: #f5f5f5; /* 背景颜色 */
  margin: 0;
  font-family: Arial, sans-serif;
}

.mobile-container-report {
  width: 100%;
  height: 100%;
  // height: 925px; /* 手机高度 */
  // width: 100%;
  // height: 925px; /* 手机高度 */
  // width: 495px; /* 手机宽度 */
  // height: 812px; /* 手机高度 */
  // width: 695px; /* 手机宽度 */
  // height: 825px; /* 手机高度 */
  // background-color: $themeColor; /* 手机外壳颜色 */
  // border-radius: 40px; /* 圆角，模拟手机边框 */
  // box-shadow: 0 8px 16px $themeColor; /* 添加阴影效果 */
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative; /* 让子元素定位 */
}




.phone-container {
  // 基础样式 (对应 w-full h-screen relative z-10 bg-white overflow-hidden)
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative; /* 让子元素定位 */
  // z-index: 10;
  width: auto;
  height: 100vh;
  aspect-ratio: $mobile-aspect-ratio;
  background-color: #ffffff;
  overflow: hidden;

  // 阴影 (对应 shadow-[0_0_80px_rgba(0,0,0,0.3)])
  box-shadow: 0 0 80px rgba(0, 0, 0, 0.3);

  // 动画过渡 (对应 transition-all duration-700 cubic-bezier(...))
  transition: all 700ms $apple-out-expo;

  // 响应式设计 (对应 md: 开头的类)
  // @media (min-width: 768px) {
  //   width: auto;
  //   height: 100vh;
  //   // 现代浏览器支持 aspect-ratio 属性
  //   aspect-ratio: $mobile-aspect-ratio;
  // }
}

/* 模拟手机外壳 */
.mobile-container {
  width: 495px; /* 手机宽度 */
  height: 100%; /* 手机高度 */

  // width: 495px; /* 手机宽度 */
  // height: 812px; /* 手机高度 */
  // width: 100%;
  // height: 925px; /* 手机高度 */
  // width: 495px; /* 手机宽度 */
  // height: 812px; /* 手机高度 */
  // width: 695px; /* 手机宽度 */
  // height: 825px; /* 手机高度 */

  // background-color: $themeColor; /* 手机外壳颜色 */
  // border-radius: 40px; /* 圆角，模拟手机边框 */
  // box-shadow: 0 8px 16px $themeColor; /* 添加阴影效果 */
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative; /* 让子元素定位 */
}

/* 手机顶部的状态栏 */
.mobile-header {
  width: 60px;
  height: 5px;
  background-color: #bbb; /* 灰色模拟扬声器 */
  border-radius: 2px;
  margin: 10px auto; /* 居中 */
}

/* 手机屏幕区域 */
.mobile-screen {
  flex: 1;
  width: 100%;
  background-color: white;
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 隐藏内容溢出 */
}
/* 手机屏幕区域 非报表 */
.mobile-screen—inner {
  flex: 1;
  width: 100%;
  background-color: white;
  // border-radius: 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 隐藏内容溢出 */
}

/* 屏幕内容顶部 */
.screen-header {
  height: 50px;
  background-color: $themeColor;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}

/* 屏幕内容区域 */
.screen-content {
  flex: 1;
  // padding: 16px;
  overflow-y: auto; /* 内容超出时滚动 */
  text-align: center;
}

/* 屏幕内容区域 */
.screen-content-new {
  // flex: 1;
  // padding: 16px;
  width: 100%;
  height: 100%;
  overflow-y: auto; /* 内容超出时滚动 */
  text-align: center;
}

/* 屏幕底部 */
.screen-footer {
  height: 50px;
  background-color: $themeColor;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}

/* 手机底部的 Home 键 */
.mobile-footer {
  width: 50px;
  height: 5px;
  background-color: #bbb; /* 灰色模拟 Home 键 */
  border-radius: 2px;
  margin: 10px auto; /* 居中 */
}
::v-deep(.van-cell__title) {
  text-align: left;
}
::v-deep(.van-cell) {
  font-size: 0.12rem;
}

.stage {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background: radial-gradient(
      800px 400px at 20% 10%,
      rgba(0, 0, 0, 0.08),
      transparent 60%
    ),
    radial-gradient(
      600px 300px at 80% 30%,
      rgba(0, 0, 0, 0.06),
      transparent 55%
    ),
    linear-gradient(180deg, #f7f8fa, #eef1f5);
}

.device {
  width: 390px; /* iPhone 15 Pro 宽度感 */
  aspect-ratio: 9 / 19.5;
  border-radius: 44px;
  padding: 14px;
  background: linear-gradient(180deg, #1b1c1f, #0e0f12);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.25), 0 10px 20px rgba(0, 0, 0, 0.18);
  position: relative;
}

/* 顶部听筒/刘海点缀（可选） */
.device::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.15);
}

.screen {
  width: 100%;
  height: 100%;
  border-radius: 34px;
  overflow: hidden;
  background: #fff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.preview-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
  background: #f0f2f5; /* 给大背景一个浅灰色，突出手机 */
}

/* 强制让你的内容充满模拟器的屏幕 */
.screen {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

/* 1. 场景容器 */
.app {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #fcfdfe; /* 极简底色 */
  overflow: hidden;
  margin: 0;
}

/* 2. 背景色彩球 (Blobs) */
.scene-blobs {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;

  &__bg {
    width: 100%;
    height: 100%;
    // filter: blur(10px);
    // opacity: 0.4;
  }
  // filter: blur(80px);
  &__logo {
    width: 3rem;
    position: fixed;
    top: 0.4rem;
    left: 0.5rem;
  }

  .blob {
    position: absolute;
    filter: blur(80px);
    opacity: 0.4;
    border-radius: 50%;
    animation: blobFloat 20s infinite alternate ease-in-out;
  }
  .blob-1 {
    width: 500px;
    height: 500px;
    background: $themeColor; // 使用你的主题绿
    top: -100px;
    left: -100px;
  }
  .blob-2 {
    width: 400px;
    height: 400px;
    background: #60a5fa; // 辅助蓝色
    bottom: -50px;
    right: -50px;
    animation-delay: -5s;
  }
  .blob-3 {
    width: 300px;
    height: 300px;
    background: #fbbf24; // 暖黄色点缀
    top: 40%;
    left: 60%;
    animation-delay: -10s;
  }
}

/* 3. 手机外壳 (iPhone 16 Pro Max 风格) */
.mobile-frame {
  position: relative;
  z-index: 10;
  width: 393px; /* 16 PM 近似比例 */
  height: 852px;
  background: rgba(255, 255, 255, 0.7); /* 钛金属感半透明 */
  backdrop-filter: blur(25px); /* 毛玻璃效果 */
  border-radius: 54px;
  padding: 10px; /* 窄边框感 */
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05),
    /* 极细描边 */ 0 20px 50px rgba(0, 0, 0, 0.1),
    /* 整体阴影 */ inset 0 0 2px rgba(255, 255, 255, 0.8);

  display: flex;
  flex-direction: column;
}

/* 4. 灵动岛 */
.dynamic-island {
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  width: 110px;
  height: 34px;
  background: #000;
  border-radius: 20px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 15px;
  .island-camera {
    width: 10px;
    height: 10px;
    background: #1a1a1a;
    border-radius: 50%;
  }
}

/* 5. 内部屏幕 */
.mobile-screen-wrapper {
  flex: 1;
  width: 100%;
  background: #fff;
  border-radius: 44px; /* 屏幕圆角 */
  overflow: hidden;
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
}

.screen-content-new {
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  } /* 隐藏滚动条 */
  scrollbar-width: none;
}

/* 6. 侧边按键 (细节控必加) */
.side-btn {
  position: absolute;
  background: #d1d5db;
  width: 3px;
  border-radius: 2px 0 0 2px;
}
.action-btn {
  height: 26px;
  top: 160px;
  left: -3px;
}
.volume-up {
  height: 50px;
  top: 210px;
  left: -3px;
}
.volume-down {
  height: 50px;
  top: 275px;
  left: -3px;
}
.sleep-btn {
  height: 80px;
  top: 230px;
  right: -3px;
  border-radius: 0 2px 2px 0;
}

/* 7. 底部 Home 指示条 */
.home-indicator {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

/* 8. 动画 */
@keyframes blobFloat {
  0% {
    transform: translate(0, 0) scale(1);
  }
  100% {
    transform: translate(40px, 60px) scale(1.1);
  }
}

// 定义复用的贝塞尔曲线
$apple-out-expo: cubic-bezier(0.16, 1, 0.3, 1);

.theme-selector {
  // display: none; // 对应 hidden
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0.4rem;
  right: 0.5rem;
  z-index: 100;

  align-items: flex-end;
  gap: 0.2rem; // 2 * 0.25rem

  // @media (min-width: 1024px) {
  //   // 对应 lg:flex

  //   // max-height: 80vh;
  // }

  .selector-header {
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.1em; // tracking-widest
    // margin-bottom: 0.25rem;

    &.text-white-40 {
      color: rgba(255, 255, 255, 0.4);
    }
    &.text-black-40 {
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .selector-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    // grid-template-cols: repeat(4, 1fr); // grid-cols-4
    // gap: 0.375rem; // 1.5 * 0.25rem
    padding: 0.05rem; // 2.5 * 0.25rem
    background-color: rgba(0, 0, 0, 0.2); // bg-black/20
    backdrop-filter: blur(12px); // backdrop-blur-md
    border-radius: 0.05rem; // rounded-2xl
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5); // shadow-2xl
    overflow-y: auto;
  }

  .theme-item {
    width: 0.45rem; // 10 * 0.25rem
    height: 0.45rem;
    border-radius: 0.13rem; // rounded-xl
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.12rem;
    font-weight: bold;
    transition: all 300ms ease;
    cursor: pointer;
    border: none;

    // 默认状态 (未激活)
    background-color: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.3);

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }

    // 激活状态
    &.is-active {
      background-color: #ffffff;
      color: #000000;
      transform: scale(1.1);
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      outline: 2px solid #22c55e; // ring-green-500
    }
  }

  .current-theme-label {
    font-size: 12px;
    font-weight: 500;
    // margin-top: 0.25rem;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 0.25rem 0.75rem;
    border-radius: 9999px; // rounded-full
    backdrop-filter: blur(4px);

    &.text-white-60 {
      color: rgba(255, 255, 255, 0.6);
    }
    &.text-black-60 {
      color: rgba(0, 0, 0, 0.6);
    }
  }
}

// 隐藏滚动条实用类
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.background-system {
  // 基础定位
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
  display: none; // hidden

  @media (min-width: 768px) {
    display: block; // md:block
  }

  // --- 1. 纹理 ---
  .pattern-overlay {
    position: absolute;
    inset: 0;
    opacity: 0.04;
    background-repeat: repeat;
  }

  // --- 2. 左侧区域 ---
  .gutter-left {
    position: absolute;
    top: 50%;
    left: 4%;
    transform: translateY(-50%);
    width: 22vw;
    max-width: 320px;
    transition: all 0.7s cubic-bezier(0.16, 1, 0.3, 1);

    .official-logo {
      width: 100%;
      height: auto;
      object-fit: contain;
      filter: drop-shadow(0 25px 25px rgba(0, 0, 0, 0.3));
    }

    .accent-line {
      margin-top: 1.5rem;
      height: 4px; // h-1
      width: 3rem; // w-12
      border-radius: 9999px;
      opacity: 0.5;
    }

    .slogan {
      margin-top: 1rem;
      font-size: 10px;
      font-weight: bold;
      letter-spacing: 0.4em;
      text-transform: uppercase;
    }
  }

  // --- 3. 右侧区域 ---
  .gutter-right {
    position: absolute;
    top: 50%;
    right: 4%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 22vw;
    max-width: 320px;

    .typo-premium {
      font-size: 5vw;
      font-weight: 900;
      font-style: italic;
      line-height: 1;
      letter-spacing: -0.05em;
      transition: color 0.5s;
    }
    .typo-warranty {
      font-size: 4vw;
      font-weight: 300;
      font-style: italic;
      line-height: 1;
      letter-spacing: -0.05em;
      margin-top: -0.5rem;
      transition: color 0.5s;
    }
    .system-tag {
      font-size: 10px;
      letter-spacing: 0.6em;
      margin-top: 2rem;
      font-weight: bold;
      text-transform: uppercase;
      text-align: right;
    }
  }

  // --- 4. 动态光束 ---
  .light-streaks {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 600px;
    transform: translateY(-50%) rotate(-10deg);
    opacity: 0.15;
    filter: blur(150px);
    transition: all 0.7s ease;
  }

  // --- 5. 光球 ---
  .glow-sphere-top {
    position: absolute;
    top: -10%;
    right: -5%;
    width: 40vw;
    height: 40vw;
    border-radius: 50%;
    filter: blur(180px);
    background-color: currentColor; // 自动继承背景色类的颜色
    opacity: 0.08;
    transition: all 1s ease;
  }

  .glow-sphere-bottom {
    position: absolute;
    bottom: -10%;
    left: -5%;
    width: 35vw;
    height: 35vw;
    border-radius: 50%;
    filter: blur(140px);
    background-color: rgba(30, 58, 138, 0.05); // blue-900/0.05
  }

  // --- 6. 底部信息 ---
  .bottom-corner-info {
    position: absolute;
    bottom: 2.5rem; // bottom-10
    left: 2.5rem;
    display: flex;
    align-items: center;
    gap: 1.25rem; // gap-5

    .vertical-bar {
      width: 4px;
      height: 2rem; // h-8
      border-radius: 9999px;
      opacity: 0.4;
      transition: color 0.5s;
    }

    .partner-text {
      font-size: 9px;
      text-transform: uppercase;
      letter-spacing: 0.5em;
      font-family: monospace;
      line-height: 1.625;
    }
  }

  // 颜色实用工具类 (代替 Tailwind 透明度语法)
  .text-white-20 {
    color: rgba(255, 255, 255, 0.2);
  }
  .text-black-20 {
    color: rgba(0, 0, 0, 0.2);
  }
  .text-white-08 {
    color: rgba(255, 255, 255, 0.08);
  }
  .text-black-08 {
    color: rgba(0, 0, 0, 0.08);
  }
  .text-white-04 {
    color: rgba(255, 255, 255, 0.04);
  }
  .text-black-04 {
    color: rgba(0, 0, 0, 0.04);
  }
}

.frame-outer {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: background-color 0.5s ease;
}

.theme-selector {
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 100;
  gap: 10px;
  background: rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 99px;

  button {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid transparent;
    transition: transform 0.3s;
    &.active {
      transform: scale(1.3);
      border-color: white;
    }
  }
}

.bg-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;

  .pattern {
    position: absolute;
    inset: 0;
    opacity: 0.05;
  }

  .brand-side {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 20vw;

    &.left {
      top: 10%;
      left: 2%;

      img {
        width: 100%;
        max-width: 260px;
        filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));
      }
      .accent-line {
        height: 4px;
        width: 40px;
        margin: 20px 0;
        border-radius: 2px;
        opacity: 0.24;
        // 并行的
        &.dark {
          background-color: white;
        }
        // 不具备的话 就是 black
        // 看上去更加语义化 避免覆盖
        &:not(.dark) {
          background-color: black;
        }
      }
      p {
        font-size: 13px;
        font-weight: bold;
        letter-spacing: 4px;
        font-style: italic;
        text-transform: uppercase;
        color: rgba(0, 0, 0, 0.1);
        &.dark {
          color: white;
          opacity: 0.24;
          // color: rgba(255, 255, 255, 0.1);
        }
        &:not(.dark) {
          opacity: 0.24;
          color: black;
        }
      }
    }

    &.right {
      right: 5%;
      text-align: right;
      h1 {
        font-size: 6vw;
        font-weight: 900;
        line-height: 1;
        color: rgba(0, 0, 0, 0.05);
        &.dark {
          color: rgba(255, 255, 255, 0.05);
        }
      }
      h2 {
        font-size: 4vw;
        font-weight: 300;
        line-height: 1;
        color: rgba(0, 0, 0, 0.03);
        &.dark {
          color: rgba(255, 255, 255, 0.03);
        }
      }
    }
  }
}

.brand-right {
  position: absolute;
  right: 6%;
  top: 60%;
  transform: translateY(-50%);
  text-align: right;

  h1 {
    font-size: 6vw;
    font-weight: 900;
    line-height: 0.9;
    opacity: 0.16;
    font-style: italic;
    &.dark {
      color: white;
    }
  }
  h2 {
    font-size: 4vw;
    font-weight: 200;
    line-height: 0.9;
    opacity: 0.14;
    font-style: italic;
    &.dark {
      color: white;
    }
  }
  .system-tag {
    margin-top: 2rem;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 6px;
    opacity: 0.24;
    font-style: italic;
    &.dark {
      color: white;
    }
    &:not(.dark) {
      opacity: 0.24;
      color: black;
    }
  }
}

.theme-panel {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  z-index: 100;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;

  .panel-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 2px;
    opacity: 0.4;
    &.dark {
      color: white;
    }
    &:not(.dark) {
      color: black;
    }
  }

  .grid-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    padding: 12px;
    background: rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    max-height: 400px;
    overflow-y: auto;
    margin: 10px 0px;

    button {
      width: 36px;
      height: 36px;
      border-radius: 10px;
      font-size: 10px;
      font-weight: bold;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      border: 2px solid transparent;

      &:hover {
        transform: translateY(-2px);
      }
      &.active {
        transform: scale(1.15);
        border-color: white;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
      }
    }
  }

  .theme-name {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 12px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 99px;
    &.dark {
      color: rgba(255, 255, 255, 0.7);
    }
    &:not(.dark) {
      color: rgba(0, 0, 0, 0.7);
    }
  }
}

// .phone-container {
//   position: relative;
//   z-index: 10;
//   width: 100%;
//   height: 100vh;
//   background: white;
//   box-shadow: 0 0 100px rgba(0, 0, 0, 0.3);
//   overflow: hidden;

//   @media (min-width: 768px) {
//     width: auto;
//     aspect-ratio: 9 / 19.5;
//     border-radius: 40px;
//     border: 8px solid #1e293b;
//     height: 90vh;
//   }
// }
</style>
